import { render } from "./CalendarBoard.vue?vue&type=template&id=78c8bb7d"
import script from "./CalendarBoard.vue?vue&type=script&lang=js"
export * from "./CalendarBoard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__